const SET_MASKED_DATA = 'DELETE_ACCOUNT/SET_MASKED_DATA'
const SET_OTP_TO_MOBILE = 'DELETE_ACCOUNT/SET_OTP_TO_MOBILE'
const SET_TIME_OUT_NOTICE = 'DELETE_ACCOUNT/SET_TIME_OUT_NOTICE'
const SET_REDIRECT_AFTER_AUTH = 'DELETE_ACCOUNT/SET_REDIRECT_AFTER_AUTH'
const SET_DELETE_ACCOUNT_REQUESTID =
  'DELETE_ACCOUNT/SET_DELETE_ACCOUNT_REQUESTID'

export {
  SET_MASKED_DATA,
  SET_OTP_TO_MOBILE,
  SET_TIME_OUT_NOTICE,
  SET_REDIRECT_AFTER_AUTH,
  SET_DELETE_ACCOUNT_REQUESTID,
}
